const cookies = {
  get: key => localStorage.getItem(key),
  set: (key, value) => localStorage.setItem(key, value)
}

const state = {
  sidebar: {
    opened: cookies.get('sidebar-status') ? !!+cookies.get('sidebar-status') : true,
    withoutAnimation: false
  },
  device: 'desktop'
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.withoutAnimation = false
    state.sidebar.opened = !state.sidebar.opened
    cookies.set('sidebar-status', state.sidebar.opened ? 1 : 0)
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    state.sidebar.opened = false
    cookies.set('sidebar-status', 0)
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
